import { getInternalMaterialProductName, SiteMaterialList } from 'api';
import { formatDate } from 'date';
import { QualityReportLink } from 'features';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Stack, Table, TableBody, TableContainer, TableHead, Typography } from 'ui';

import { ViewManageButton } from '../../components/VieManageButton/ViewManageButton';
import { StyledTableCell, StyledTableRow } from './styles';

const getSiteMaterialName = (siteMaterial: SiteMaterialList): string => {
  const materialProduct = siteMaterial.material_product;
  let materialName = '';
  if (materialProduct) {
    materialName = getInternalMaterialProductName(materialProduct);
  } else {
    materialName = siteMaterial.material_spec.title + ' - ' + siteMaterial.grade.name;
  }
  if (siteMaterial.seller_label) {
    materialName += ' - Seller label: ' + siteMaterial.seller_label;
  }
  return materialName;
};

export const SiteMaterialsList = ({
  siteName,
  siteMaterials,
  onRowClick,
  tradeCompanyId,
}: {
  siteMaterials: SiteMaterialList[];
  siteName: string;
  onRowClick?: (id: number) => void;
  tradeCompanyId?: number;
}) => {
  const navigate = useNavigate();
  return (
    <Box mb={4}>
      <Box pl={1.25} mb={1}>
        <Typography variant="body1" fontWeight="bold">
          {siteName}
        </Typography>
      </Box>

      <TableContainer>
        <Table>
          <TableHead>
            <StyledTableRow sx={(theme) => ({ color: theme.palette.text.secondary })}>
              <StyledTableCell>Material</StyledTableCell>
              <StyledTableCell>Last updated</StyledTableCell>
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {siteMaterials.map((row) => (
              <StyledTableRow key={row.id} clickableRow={Boolean(onRowClick)}>
                <StyledTableCell
                  sx={{
                    minWidth: '250px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                  onClick={() => onRowClick?.(row.id)}
                >
                  {getSiteMaterialName(row)}
                </StyledTableCell>
                <StyledTableCell onClick={() => onRowClick?.(row.id)}>{formatDate(row.updated_at)}</StyledTableCell>
                <StyledTableCell sx={{ justifyContent: 'right' }}>
                  <Stack direction="row" gap={1.5} justifyContent="end">
                    <Button variant="secondary" onClick={() => navigate(`${row.id}/update/`)}>
                      Edit/Assign Product
                    </Button>
                    <Box>
                      <QualityReportLink
                        siteMaterialPublicId={row.public_id}
                        size="medium"
                        tradeCompanyId={tradeCompanyId}
                      />
                    </Box>
                    <ViewManageButton siteMaterialId={row.id} />
                  </Stack>
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
